import React, { Component} from "react"
import PropTypes from "prop-types"
import { useParams, useHistory, withRouter } from "react-router-dom";
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import { getTempById } from "../../../store/templates/actions"
import InEditor from "./editor"
import {
    Row,
    Col,
    Container,
    Nav,
    NavItem,
    Tooltip
  } from "reactstrap"
import { param } from "jquery";
import InviteUnEditor from "../Email/invite-unlayer";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import RsLink from "components/buttons/rsLink";
import { toast, ToastContainer } from "react-toastify";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import { getProjectUUIDAction } from "store/actions";

class projectInviteEditor extends Component {
  
  constructor(props) {
    super(props);
    this.editor = null;
    this.isEditorLoaded = false;
    this.isComponentMounted = false
    this.LoadUnlayerRef = React.createRef();   

}
  componentDidMount() {

    const { match: { params }, onGetTempId, ongetProjectUUIDAction } = this.props;
    this.isComponentMounted = true;
    this.loadTemplate();
    if (params && params.projectId && params.id) {
      onGetTempId(params.templateId);
     
    }
     ongetProjectUUIDAction(params.id)
 }  

  onLoad = () => { this.isEditorLoaded = true; this.loadTemplate(); } 
  loadTemplate = () => { if (!this.isEditorLoaded || !this.isComponentMounted) return; this.editor.loadDesign('<p>Your HTML content goes here</p>') }

   exportHtml = () => {

          if (this.LoadUnlayerRef && this.LoadUnlayerRef.current) {
        
            this.LoadUnlayerRef.current.exportHtml((htmlContent) => {

                const payload = {
                        
                        //projectEmailCampaignId: 0,
                        emailCampaignProjectId: this.props.projectData.id,
                        campaignProjectGuid:this.props.match.params.id,
                        emailCampaignTemplateId: parseInt(this.props.match.params.templateId),
                        emailCampaignCss:'',
                        emailCampaignFullContent: JSON.stringify(htmlContent.design),
                        agentId: parseInt(localStorage.getItem("userId")),
                        isActive: true,
                        emailCampaignTitle: '',
                        emailCampaignSubject: '',
                        emailCampaignContent:  htmlContent.html,
                        emailCampaignFullContent: JSON.stringify(htmlContent.design),
                        emailCampaignListIds: '',
                        emailTargetTypeId: 0,
                        emailTargetSubTypeId: 0,
                        emailTargetFilter: '',
                        emailCampaignSchedule: new Date(),
                        emailCampaignSendStatus: '',   
                        emailCampaignPublishStatus: '',
                    };
           
                  const obj = JSON.parse(localStorage.getItem("authUser"));
                    const token = obj.resultData.bearerToken;
                    const str = 'Bearer ' + token;
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': str
                    }
                    
                    toast.loading("Please wait...");
                   
                    axios.post(`${API_URL}ProjectEmailCampaign`, payload, {
                        headers: headers
                      })
                      .then((response) => {
                          toast.dismiss();
                        
                          this.props.history.push('/pre-construction/mail-send/' + response.data.projectEmailCampaign.id + '/' + response.data.projectEmailCampaign.projectEmailCampaignId);
                      })
                      .catch((error) => {
                        
                      }) 
                  });

             
  
          }
        };
      render() {
        const { datatemp, projectData } = this.props;
        return (
          <React.Fragment>
              <div className="page-content">

                <MetaTags>
                <title>Campaigns | Realty Space</title>
                </MetaTags>
                <ToastContainer autoClose={2000} />
                <Container fluid>
                  
                {/* Render Breadcrumbs */}
            
                    <span className="float-start mb20">
                         <RsLink className="btn btn-light btn-md" iconClass="bx bx-arrow-back" to={`/pre-construction/campaign/rsvp/`+ this.props.match.params.id}>
                          Back
                      </RsLink>{" "}

                    </span>
                    <span className="float-end">
           
        <Link to="#" onClick={this.exportHtml}><button
              
              className="btn btn-primary w-md me-2"
              style={{ marginBottom: 20 }}
            >s
              Save & Continue
            </button></Link>
            </span>
             <div className="clearfix"></div>
                <Row>
                   
                    <Col lg="12">
                    
            <div className="clearfix"></div>
                        <InviteUnEditor  ref={this.LoadUnlayerRef} />
                       
               
                
                   
                    </Col>
                </Row>
                <Row>
                   
                </Row>
                </Container>
            </div>
          </React.Fragment>
        )
      }
}

projectInviteEditor.propTypes = {
    t:PropTypes.any,
    history:PropTypes.object,
    match:PropTypes.object,
    onGetTempId:PropTypes.func,
    datatemp:PropTypes.object,
    ongetProjectUUIDAction:PropTypes.func,
    projectData: PropTypes.object
  }
  const mapStateToProps = ({ Project, Template }) => (
    {
      datatemp : Template.datatemp,
      loading:Project.loading,
      projectData: Project.projectData
  
    })
  const mapDispatchToProps = dispatch => ({
     ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
    onGetTempId:(id) => dispatch(getTempById(id))
  });
export default connect( mapStateToProps,mapDispatchToProps )(withRouter(withTranslation()(projectInviteEditor)))
